import { MutationTree } from 'vuex'
import { IShoppingCartState, IPlan, IProductExtended } from '@/@types'

const mutations: MutationTree<IShoppingCartState> = {
  SHOPPING_CART_UPDATED: (state, shoppingCart: Array<IPlan | IProductExtended>) => {
    state.shoppingCart = shoppingCart
  },
  COUPON_UPDATED: (state, coupon: string) => {
    state.coupon = coupon
  },
}

export default mutations
